<script setup>
import SectionTitle from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/SectionTitle.vue'

const linkList = [
  '8101030001',
  '8202090001',
  '8202110001',
  '8202040001',
  '8303030001',
  '8303040001',
  '8303050001',
  '8404030001',
  '8505090001',
  '8505050001',
  '8505080001',
  '8606040001',
  '8707050001',
  '8808070001',
  '8909060001',
  '8909110001'
]
const { data: riverList } = await useRiverList()

const riverText = (code) => {
  const river = riverList.value?.find((r) => r.code === code)
  if (!river) return ''
  return river.name
}
const prefText = (code) => {
  const river = riverList.value?.find((r) => r.code === code)
  if (!river) return ''
  return river.pref.split(',')
    .filter(Boolean)
    .map((p) => p.replace(/[都府県]$/, ''))
    .join('・')
}
</script>

<template>
  <section class="riverLinks">
    <div class="head">
      <SectionTitle title="主要河川の水位情報" />
    </div>
    <div class="content">
      <NuxtLink
        v-for="(item, index) in linkList"
        :key="index"
        :to="`/${item}/`"
        class="link"
      >
        {{ riverText(item) }}（{{ prefText(item) }}）
      </NuxtLink>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.riverLinks {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 10px;
    border-radius: 6px;
    background-color: #EEF1F8;
  }
  .link {
    padding: 7px 10px;
    border-radius: 4px;
    background-color: #FFF;
    box-shadow: 0 2px 4px 0 rgb(0 0 0 / .15);
    color: #303030;
    font-size: 13px;
    font-weight: 600;
    line-height: 1em;
  }
  @media (any-hover: hover) {
    .link {
      transition: opacity .2s ease-in-out;
      cursor: pointer;
      &:hover {
        opacity: .6;
      }
    }
  }
}
.main {
  .riverLinks {
    @media (min-width: 830px) {
    }
  }
}
</style>
